
import { Card, CardContent } from "@/components/ui/card";

const differentiators = [
  {
    title: "Dynamic & Research-Driven",
    description: "Uses real-time AI insights instead of outdated benchmarks, ensuring your assessment reflects current market conditions."
  },
  {
    title: "Industry-Specific",
    description: "Recognizes that AI adoption trends vary significantly by industry, providing relevant comparisons and insights."
  },
  {
    title: "Action-Oriented",
    description: "Generates detailed, personalized AI adoption roadmaps tailored to your organization's specific needs and goals."
  },
  {
    title: "Comprehensive Support",
    description: "Offers ongoing guidance and progress tracking to ensure successful implementation of recommendations."
  }
];

export const WhyAIMAA = () => {
  return (
    <section className="mb-8 sm:mb-16 animate-fade-in" style={{ animationDelay: "300ms" }}>
      <h2 className="text-xl sm:text-2xl font-semibold text-[#0f2d69] mb-4 sm:mb-6">What Makes AIMAA Different?</h2>
      <Card className="bg-white/50 hover:shadow-lg transition-all duration-300">
        <CardContent className="pt-6">
          <div className="grid sm:grid-cols-2 gap-6">
            {differentiators.map((item, index) => (
              <div 
                key={index} 
                className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
              >
                <h3 className="font-semibold text-[#0f2d69] mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
